import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { TokenControllerService } from '@app/messages-sdk/services/token-controller.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.scss'],
})
export class PermissionComponent implements OnInit {

  @Input() title?: string;
  @Input() message?: string;
  @Input() buttons?: { title: string, value?: string }[];
  public environment = environment;

  constructor(
    private modal: ModalController,
    private tokenController: TokenControllerService,
    private storage: Storage
  ) { }

  ngOnInit() { }

  async onButtonClick(value: any) {
    try {
      if (String(value) === 'allow-push-ios') {
        const fn = (window as any).requestIosPushPermissions;
        if (typeof fn === 'function') {
          const token: string | null = await fn();
          if (token) {
            try {
              await this.tokenController.registerIosDeviceToken({ endpoint: token });
              await this.storage.set('tokenDevice', token);
              // opcional: podríamos notificar éxito al usuario.
            } catch (e) {
              console.warn('[PermissionComponent] Error registrando token iOS', e);
            }
          }
        }
      }
    } finally {
      return this.modal.dismiss({ value });
    }
  }

  // Llamable directo desde template si se prefiere un botón dedicado
  async askIosPush() {
    await this.onButtonClick('allow-push-ios');
  }
}
